import { Component, OnInit, NgZone, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { TranslateService } from '../../../_services/translate.service';
import { AnpiService } from '../../../_services/anpi-code.service';
import { Location, DatePipe } from '@angular/common';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
declare var $: any;

@Component({
  selector: 'app-cnamgs-form',
  templateUrl: './cnamgs-form.component.html',
  styleUrls: ['./cnamgs-form.component.scss']
})
export class CnamgsFormComponent implements OnInit {

  public cnamgsForm: FormGroup;
  public todayDate: Date = new Date();
  startat = new Date();
  isSubmitted = false;
  response: any;
  bankDetails: any;
  bankdata: any;
  regionList: any;
  companyDetails: any;
  neighborhoodlist: any;
  districtList: any;
  accountDetails: any;
  isDisable: any;
  countryList: any;
  idproofList: any;
  rejectReason: any;
  takeover_date: any;
  cnamgs_url: any;
  date_of_birth: any;
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private translate: TranslateService,
    private anpiService: AnpiService,
    private location: Location,
    private ngzone: NgZone,
    private datePipe: DatePipe,
    private elementRef: ElementRef,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar) {
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      console.log(this.accountDetails)
    }
    if (this.router.getCurrentNavigation().extras.state) {
      console.log("54", this.router.getCurrentNavigation().extras.state)
      const data = this.router.getCurrentNavigation().extras.state.show_modal
      console.log(this.router.getCurrentNavigation().extras.state.show_modal)
      console.log(data)
      if (data == 1) {
        setTimeout(() => {
          console.log("60")
          $('#successModal').modal('show');
        }, 500);
      }
    }
  }
  ngOnInit() {
    console.log(this.todayDate)
    this.startat.setHours(0, 0, 0, 0);
    this.cnamgsForm = this.formBuilder.group({
      // company_name: [''],
      // trade_name: [''],
      // sigle: [''],
      // district: [''],
      // neighborhood: [''],
      // rue: [''],
      // door_address: [''],
      // place: [''],
      // locality: [''],
      // region: [''],
      // contact_1: [''],
      // bp: [''],
      // contact_2: [''],
      // fax: [''],
      // email: [''],
      // website: [''],
      // legal_status: [''],
      // employer_plan: [''],
      // tax_no: [''],
      // rccm: [''],
      // nif: [''],
      // seeg_subscription_no: [''],
      // guardianship: [''],
      // branch_of_activity: [''],
      // workers_men: [''],
      // workers_women: [''],
      // women_interns: [''],
      // men_interns: [''],
      // employer_cnamgs: [''],
      //new values
      // administration_name: [''],
      // local_community: [''],
      // department: [''],
      // municipality: [''],
      // township: [''],
      // takeover_date: [''],
      // business_manager: [''],
      // maiden_name: [''],
      // position: [''],
      // lastname: [''],
      // firstname: [''],
      // birthdate: [''],
      // birthplace: [''],
      // country: [''],
      // nationality: [''],
      manager: [],
      // date_of_creation: [''],
      // activity: [''],
      // employer_fund: [''],
      // employer_code: [''],
      // idproof: [''],
      // idnumber: [''],
      // address: [''],
      // phoneno: [''],
      // owner_email: [''],
      // insurrance_no: [''],
      // current_date: [''],
      // signature: [''],
      //new values end
      created_date: ['', Validators.required],
      service_start_date: ['', Validators.required],
      confirm_account: ['', [Validators.requiredTrue]],
      selected_bank_id: this.formBuilder.array([])

    });

    if (!this.api.getValidationStatus()) {
      this.api.getFormValidation(this.cnamgsForm);
    }
    this.getCountryData();
    this.getRegionData();
    this.getDistrictData();
    // this.getNeighbourhoodList();
    this.getCnamgsData();
    this.getIdProofList();

  }

  onSubmitCnamgsForm() {
    console.log("61", this.cnamgsForm.getRawValue());
    console.log("6", this.cnamgsForm);
    this.isSubmitted = true;
    if (this.cnamgsForm.invalid) {
      console.log("61", this.cnamgsForm.getRawValue());
      console.log("97", this.cnamgsForm.value);
      this.scrollToFirstInvalidControl();
      return;
    }
    var data = {
      created_date: this.f.created_date.value,
      service_start_date: this.f.service_start_date.value
    }
    delete data['confirm_account'];
    data['created_date'] = this.convertOwl(data.created_date);
    data['service_start_date'] = this.convertOwl(data.service_start_date);
    data['uuid'] = this.companyDetails.uuid;
    console.log("100", data)
    this.ngxUiLoaderService.start();
    this.api.cnamgsApprovalForm(data).pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
            this.isSubmitted = false;
            this.router.navigate(['/dashboard'], { state: { show_modal: '3' } });

          } else {
            this.isSubmitted = false;
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.isSubmitted = false;
          this.ngxUiLoaderService.stop();
        });

  }
  // getFormArrayValues(formArray: FormArray): any[] {
  //   const values = [];
  //   formArray.controls.forEach(control => {
  //     values.push(control.value);
  //   });
  //   return values;
  // }
  // makeInputReadOnly() {
  //   Object.keys(this.cnamgsForm.controls).forEach(controlName => {
  //     const control = this.cnamgsForm.get(controlName);
  //     if (control && control.value !== null && control.value !== undefined && control.value !== '') {
  //       control.disable();
  //     }
  //   });
  // }
  getIdProofList() {
    let data = {
      identityType: '2'
    }
    this.api.getidTypeList(data).pipe(first())
      .subscribe(res => {
          this.response = res;
          console.log("682", this.response)
          if (this.response.status == 200) {
            this.idproofList = this.response.results;
            console.log("685", this.idproofList)
          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {});
  }
  getCountryData() {

    this.api.getCountryList().pipe(first())
      .subscribe(res => {
          this.response = res;
          if (this.response.status == 200) {
            this.countryList = this.response.results;
            console.log("503", this.countryList)
          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {

        });
  }
  setCnamgsFormValues() {
    console.log("138")
    // this.cnamgsForm.controls['company_name'].setValue(this.companyDetails.name);
    // this.cnamgsForm.controls['trade_name'].setValue(this.companyDetails.trade_name);
    // this.cnamgsForm.controls['sigle'].setValue(this.companyDetails.acrononym);
    // this.cnamgsForm.controls['district'].setValue(this.companyDetails.district);
    // this.cnamgsForm.controls['neighborhood'].setValue(this.companyDetails.owener_neighbourhood_name);
    // this.cnamgsForm.controls['rue'].setValue(this.companyDetails.street);
    // this.cnamgsForm.controls['door_address'].setValue(this.companyDetails.door_no);
    // this.cnamgsForm.controls['place'].setValue(this.companyDetails.place);
    // this.cnamgsForm.controls['locality'].setValue(this.companyDetails.locality);
    // this.cnamgsForm.controls['region'].setValue(this.companyDetails.owner_region_name);
    // this.cnamgsForm.controls['contact_1'].setValue(this.companyDetails.contact_1);
    // this.cnamgsForm.controls['bp'].setValue(this.companyDetails.owner_post_box);
    // this.cnamgsForm.controls['contact_2'].setValue(this.companyDetails.contact_2);
    // this.cnamgsForm.controls['fax'].setValue(this.companyDetails.fax);
    // this.cnamgsForm.controls['email'].setValue(this.companyDetails.owner_email);
    // this.cnamgsForm.controls['website'].setValue(this.companyDetails.website);
    this.cnamgsForm.controls['created_date'].setValue(this.companyDetails.created_date);
    this.cnamgsForm.controls['service_start_date'].setValue(this.companyDetails.service_start_date);
    // this.cnamgsForm.controls['legal_status'].setValue(this.companyDetails.legal_status);
    // this.cnamgsForm.controls['employer_plan'].setValue(this.companyDetails.employer_plan);
    // this.cnamgsForm.controls['tax_no'].setValue(this.companyDetails.tax);
    // this.cnamgsForm.controls['rccm'].setValue(this.companyDetails.rccm);
    // this.cnamgsForm.controls['nif'].setValue(this.companyDetails.nif);
    // this.cnamgsForm.controls['seeg_subscription_no'].setValue(this.companyDetails.seeg_subscription_no);
    // this.cnamgsForm.controls['guardianship'].setValue(this.companyDetails.guardianship);
    // this.cnamgsForm.controls['branch_of_activity'].setValue(this.companyDetails.branch_of_activity);
    // this.cnamgsForm.controls['workers_men'].setValue(this.companyDetails.workers_men);
    // this.cnamgsForm.controls['workers_women'].setValue(this.companyDetails.workers_women);
    //new fields
    // this.cnamgsForm.controls['administration_name'].setValue(this.companyDetails.administration_name);
    // this.cnamgsForm.controls['local_community'].setValue(this.companyDetails.local_community);
    // this.cnamgsForm.controls['department'].setValue(this.companyDetails.department);
    // this.cnamgsForm.controls['municipality'].setValue(this.companyDetails.municipality);
    // this.cnamgsForm.controls['township'].setValue(this.companyDetails.township);
    // this.cnamgsForm.controls['takeover_date'].setValue(this.companyDetails.takeover_date);
    // this.cnamgsForm.controls['business_manager'].setValue(this.companyDetails.business_manager);
    // this.cnamgsForm.controls['maiden_name'].setValue(this.companyDetails.maiden_name);
    // this.cnamgsForm.controls['position'].setValue(this.companyDetails.position);
    // this.cnamgsForm.controls['lastname'].setValue(this.companyDetails.lastname);
    // this.cnamgsForm.controls['firstname'].setValue(this.companyDetails.firstname);
    // this.cnamgsForm.controls['birthdate'].setValue(this.companyDetails.birthdate);
    // this.cnamgsForm.controls['birthplace'].setValue(this.companyDetails.birthplace);
    // this.cnamgsForm.controls['country'].setValue(this.companyDetails.country);
    // this.cnamgsForm.controls['nationality'].setValue(this.companyDetails.nationality);
    // if (this.companyDetails.manager) {
    //   this.cnamgsForm.controls['manager'].setValue(Number(this.companyDetails.manager));
    // }
    if (this.companyDetails.manager != null) {
      this.cnamgsForm.controls['manager'].setValue(Number(this.companyDetails.manager));
    }
    // this.cnamgsForm.controls['date_of_creation'].setValue(this.companyDetails.date_of_creation);
    // this.cnamgsForm.controls['activity'].setValue(this.companyDetails.activity);
    // this.cnamgsForm.controls['employer_fund'].setValue(this.companyDetails.employer_fund);
    // this.cnamgsForm.controls['employer_code'].setValue(this.companyDetails.employer_code);
    // this.cnamgsForm.controls['idproof'].setValue(this.companyDetails.idproof);
    // this.cnamgsForm.controls['idnumber'].setValue(this.companyDetails.idnumber);
    // this.cnamgsForm.controls['address'].setValue(this.companyDetails.address);
    // this.cnamgsForm.controls['phoneno'].setValue(this.companyDetails.phoneno);
    // this.cnamgsForm.controls['owner_email'].setValue(this.companyDetails.owner_email);
    // this.cnamgsForm.controls['insurrance_no'].setValue(this.companyDetails.insurrance_no);
    // this.cnamgsForm.controls['current_date'].setValue(this.companyDetails.current_date);
    // this.cnamgsForm.controls['men_interns'].setValue(this.companyDetails.men_interns);
    // this.cnamgsForm.controls['women_interns'].setValue(this.companyDetails.women_interns);
    this.takeover_date = this.datePipe.transform(this.companyDetails.takeover_date, 'dd-MM-yyyy');
    this.date_of_birth = this.datePipe.transform(this.companyDetails.birth_date, 'dd-MM-yyyy');
    console.log("296", this.takeover_date)
    console.log("297", this.date_of_birth)
    if (this.bankdata) {
      this.bankdata.forEach(item => {
        this.selectedBanks.push(this.formBuilder.control(item.bank_id));
      });
    } else {
      this.selectedBanks.clearValidators();
      this.selectedBanks.updateValueAndValidity();
    }
    console.log(this.cnamgsForm.value)
    // const initialValue = this.cnamgsForm.get('banks').value;
    // if(initialValue){
    //   this.showSelectedGridChild(initialValue);
    // }    
  }
  get selectedBanks(): FormArray {
    return this.cnamgsForm.get('selected_bank_id') as FormArray;
  }
  getRegionData() {
    this.ngxUiLoaderService.start();
    this.api.getRegionList().pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res;
          console.log("541", this.response)
          if (this.response.status == 200) {
            this.regionList = this.response.results;
            console.log("522", this.regionList)
          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
  getDistrictData() {
    this.ngxUiLoaderService.start();
    this.api.getDistrictData().pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res;
          console.log("211", this.response)
          if (this.response.status == 200) {
            this.districtList = this.response.results;
            console.log("214", this.districtList)
          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
  // getNeighbourhoodList() {
  //   console.log("612")
  //   this.ngxUiLoaderService.start();
  //   this.api.getNeighbourhoodList().pipe(first())
  //     .subscribe(res => {
  //         this.ngxUiLoaderService.stop();
  //         this.response = res;
  //         console.log("208", this.response)
  //         if (this.response.status == 200) {
  //           if (this.response.results.length === 0) {
  //             // this.f.neighbourhood.clearValidators();
  //             // this.f.neighbourhood.updateValueAndValidity();
  //           } else {
  //             this.neighborhoodlist = this.response.results;
  //             console.log("345", this.neighborhoodlist)
  //           }
  //         } else {
  //           this.snackBar.open(res.message, "OK", {
  //             duration: 5000,
  //           });
  //         }
  //       },
  //       error => {
  //         this.ngxUiLoaderService.stop();
  //       });
  // }
  getCnamgsData() {
    this.ngxUiLoaderService.start();
    this.api.getCnamgsApprovalData().pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          console.log("237", data);
          if (this.response.status == 200) {
            this.bankdata = this.response.bank_details;
            this.companyDetails = this.response.company_details;
            this.rejectReason = this.response.verification;
            this.cnamgs_url = this.response.cnamgs_url;
            console.log("239", this.rejectReason)
            if (this.companyDetails) {
              this.setCnamgsFormValues();
            }
          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.isSubmitted = false;
          this.ngxUiLoaderService.stop();
        });
  }

  get f() {
    return this.cnamgsForm.controls;
  }

  goback() {
    this.location.back();
  }
  convertOwl(str) {
    if (str == null)
      return str;
    var mnths = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12"
      },
      date = str.toString().split(" ");
    if (date.length == 1)
      return str;
    else
      return [date[2], mnths[date[1]], date[3]].join("-");
  }
  // handleChange(e, value, val) {
  //   console.log(value)
  //   console.log()
  //   if (val == 1) {
  //     this.cnamgsForm.controls['bank_name'].setValue(value);
  //   } else {
  //     this.cnamgsForm.controls['facility_name'].setValue(value);
  //   }
  // }

  onChange(id: string, isChecked: boolean) {

    if (isChecked) {
      console.log("333")
      this.selectedBanks.push(this.formBuilder.control(id));
    } else {
      console.log("336")
      const index = this.selectedBanks.controls.findIndex(x => x.value === id);
      this.selectedBanks.removeAt(index);
    }
  }
  goToLinkBusiness() {
    this.router.navigate(['/link-business'], { fragment: 'cnamgsresubmit' })
  }


  scrollToFirstInvalidControl() {
    for (const controlName in this.cnamgsForm.controls) {
      const control = this.cnamgsForm.get(controlName);
      if (control.invalid) {
        const firstInvalidControl = this.elementRef.nativeElement.querySelector(`[formcontrolname="${controlName}"]`);
        if (firstInvalidControl) {
          firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          break; // Stop after scrolling to the first invalid control
        }
      }
    }
  }
}
